import core from '@/helpers/client'

const productRegisterService = {
  async getDeliveryTypeByInventoryAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/productregisters/deliverytype`,
      params
    )
    return result
  },
  async createApproveProductRegisterAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/productregisters/approval`,
      model
    )
    return result
  },
  async createImportApproveProductRegisterAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/productregisters/importedProductApproval`,
      model,null,false
    )
    return result
  },
}
export default productRegisterService
